import Flex from '@Resources/styles/flex.scss';
import { Card, Skeleton } from '@mui/material';
import cx from 'classnames';
import React from 'react';
import Styles from './ProjectCard.scss';

const ProjectCardSkeleton = (props) => {
    const textWidth = Math.floor(Math.random() * (100 - 35 + 1) + 35);
    return (
        <Card className={Styles.pcContainer}>
            <div className={Styles.pcContent}>
                <div className={Styles.pcContentContainer}>
                    <div className={Styles.pcMediaContainer}>
                        <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={'4rem'}
                            height={'4rem'}
                            style={{ borderRadius: '1rem' }}
                        />
                    </div>
                    <div className={Styles.pcTitleContainer}>
                        {/* <div className={cx(Flex.flex, Flex.column, Flex.grow)}> */}
                        <Skeleton
                            animation="wave"
                            height={10}
                            width={`${textWidth}%`}
                        />
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ProjectCardSkeleton;
